/**
 * @interface ResumeRepository
 * Abstract interface for resume data access.
 * Swap implementations to change backend (Firebase, Supabase, etc.)
 */
export class ResumeRepository {
  /** @returns {Promise<Resume>} */
  async create(resume) { throw new Error('Not implemented'); }

  /** @returns {Promise<Resume|null>} */
  async getById(id) { throw new Error('Not implemented'); }

  /** @returns {Promise<Resume|null>} */
  async getByUserId(userId) { throw new Error('Not implemented'); }

  /** @returns {Promise<void>} */
  async update(id, data) { throw new Error('Not implemented'); }

  /** @returns {Promise<void>} */
  async delete(id) { throw new Error('Not implemented'); }

  /** @returns {Promise<Resume|null>} - Public resume data (sanitized) */
  async getPublicResume(id) { throw new Error('Not implemented'); }
}
